<script>
  import { Confirm } from "svelte-confirm";
  import { modalReservation, User } from "../../store";
  import fetchNodeProduction from "../../helpers/FetchNodeProduction.js";
  import Toggle from "./Toggle.svelte";
  let loading = false;
  let loadingFetch = false;
  export let message;
  export let error;

  let reservation;
  let ProductionReservation;
  let reservationBreakdown;
  let feeStructure;
  let queueForRemoval;
  let paymentStatuses;
  let guestPaymentMethod;
  let stripe;
  let paymentMethods = ['Cash', 'Credit Card', 'Bank transfer'];

  modalReservation.subscribe((value) => {
    reservation = value;
    init();
  });

  async function init() {
    loading = true;
    message = "";
    error = "";
    reservationBreakdown = [];
    queueForRemoval = [];
    paymentStatuses = [""];
    guestPaymentMethod = [""];
    stripe = false;

    await getReservationFromProduction();
    await getBreakdowns();
    await getFeeStructure();
    loading = false;
  }  
  function findPaymentStatuses(columns) {
    const paymentStatusesFilter = columns.filter(
      (column) => column.column == "paymentStatus"
    );
    paymentStatuses = [...paymentStatuses, ...paymentStatusesFilter[0].options];
    paymentStatuses = paymentStatuses;
  }
  function findGuestPayment(columns) {
    const guestPaymentFilter = columns.filter(
      (column) => column.column == "guestPayment"
    );
    guestPaymentMethod = [...guestPaymentMethod, ...guestPaymentFilter[0].options];
    guestPaymentMethod = guestPaymentMethod;
  }
  function stripeStatus(){
    if(!ProductionReservation.stripeInvoiceId){
      guestPaymentMethod.pop()
      guestPaymentMethod = guestPaymentMethod;
    } else {
      stripe = true;
    }
  }
  async function getReservationFromProduction() {
    const response = await fetchNodeProduction(
      "/getReservations?filter=%7B%22id%22:" + reservation.id + "%7D",
      null,
      "GET"
    );
    if (typeof response === "object") {
      if (response.status == true) {
        findGuestPayment(response.columns);
        findPaymentStatuses(response.columns);
        ProductionReservation = response.data[0];
        stripeStatus();
      } else {
        error = parseMessage(response);
      }
    }    
  }
  async function getBreakdowns() {
    const response = await fetchNodeProduction(
      "/getReservationBreakdowns?reservationId=" + reservation.id,
      null,
      "GET"
    );
    if (typeof response === "object") {
      if (response.status == true) {
        reservationBreakdown = response.data;
        if (reservationBreakdown.length == 0) {
          addBreakdownLine(-1);
        }
        recalculateAll();
      } else {
        error = parseMessage(response);
      }
    }
  }
  async function getFeeStructure() {
    const response = await fetchNodeProduction("/getFeeStructure", null, "GET");
    if (typeof response === "object") {
      if (response.feeTypes) {
        feeStructure = response;
        feeStructure.feeTypes.push(ProductionReservation.currency);
      } else {
        error = parseMessage(response);
      }
    }
  }
  async function deleteFee(id) {
    const formData = new FormData();
    formData.append("id", id);
    const response = await fetchNodeProduction(
      "/deleteReservationBreakdowns",
      formData
    );
    if (typeof response === "object") {
      if (response.status) {
        message = parseMessage(response.data);
      } else {
        error = parseMessage(response);
      }
    }
  }
  async function storeReservationBreakdowns() {
    const formData = new FormData();
    formData.append("reservationId", ProductionReservation.id);
    formData.append(
      "resBreakdownStructure",
      JSON.stringify(reservationBreakdown)
    );
    const response = await fetchNodeProduction(
      "/storeReservationBreakdowns",
      formData
    );
    if (typeof response === "object") {
      if (response.status) {
        message = parseMessage(response);
      } else {
        error = parseMessage(response);
      }
    }
  }
  function parseMessage(data) {
    const { message } = data;
    if (message == "token expired") {
      User.logout();
    }
    if (message.part1) {
      return `${message.part1 || ""} ${message.part2 || ""} ${
        message.part3 || ""
      } ${message.part4 || ""}`;
    }
    return message;
  }

  function removeBreakdownIndex(index) {
    if (reservationBreakdown[index].id !== 0) {
      queueForRemoval.push(reservationBreakdown[index]);
      queueForRemoval = queueForRemoval;
    }
    reservationBreakdown.splice(index, 1);
    reservationBreakdown = reservationBreakdown;
  }
  function addBreakdownLine(index) {
    const newFee = {
      id: 0,
      reservationId: ProductionReservation.id,
      airbetterId: ProductionReservation.airbetterId,
      feeId: null,
      type: "",
      fee: 0,
      feeType: ProductionReservation.currency,
      feeUnit: "Per stay",
      totalFee: 0,
      feeCurrency: ProductionReservation.currency,
      description: "",
      deductFee: 1,
      sort: index + 1,
    };

    reservationBreakdown.push(newFee);
    reservationBreakdown = reservationBreakdown;
  }

  function recalculateAll() {
    for (let i = 0; i < reservationBreakdown.length; i++) {
      recalculateRow(i, false);
    }
    sumTotals();
  }
  function recalculateRow(i, sumTotals) {
    let sell = ProductionReservation.sellRateValue;
    let comm = ProductionReservation.commissionableRateValue;
    let people = ProductionReservation.numberOfGuests;
    let nights = ProductionReservation.nights;

    let fee = +reservationBreakdown[i].fee;
    let baseRate = 0;
    switch (reservationBreakdown[i].feeType) {
      case "% of commissionable rate": {
        baseRate = (fee / 100) * comm;
        break;
      }
      case "% of sell rate": {
        baseRate = (fee / 100) * sell;
        break;
      }
      case "USD": {
        baseRate = reservationBreakdown[i].fee;
        break;
      }
      case "GBP": {
        baseRate = reservationBreakdown[i].fee;
        break;
      }
    }
    switch (reservationBreakdown[i].feeUnit) {
      case "Per stay": {
        baseRate = baseRate * 1;
        break;
      }
      case "Per night": {
        baseRate = baseRate * nights;
        break;
      }
      case "Per person per stay": {
        baseRate = baseRate * people;
        break;
      }
      case "Per person per night": {
        baseRate = baseRate * people * nights;
        break;
      }
    }
    reservationBreakdown[i].totalFee = baseRate.toFixed(2);
    if (sumTotals) {
      sumTotals();
    }
  }
  function sumTotals() {
    let channelCommissionRate = 0;
    let channelVat = 0;
    let airbetterRate = 0;
    let airbetterVat = 0;
    let serviceCosts = 0;
    for (let i = 0; i < reservationBreakdown.length; i++) {
      switch (reservationBreakdown[i].type) {
        case "Channel commission": {
          channelCommissionRate +=
            reservationBreakdown[i].deductFee == 0
              ? 0
              : +reservationBreakdown[i].totalFee;
          break;
        }
        case "Channel VAT": {
          channelVat +=
            reservationBreakdown[i].deductFee == 0
              ? 0
              : +reservationBreakdown[i].totalFee;
          break;
        }
        case "Airbetter commission": {
          airbetterRate +=
            reservationBreakdown[i].deductFee == 0
              ? 0
              : +reservationBreakdown[i].totalFee;
          break;
        }
        case "Airbetter VAT": {
          airbetterVat +=
            reservationBreakdown[i].deductFee == 0
              ? 0
              : +reservationBreakdown[i].totalFee;
          break;
        }
        default: {
          serviceCosts +=
            reservationBreakdown[i].deductFee == 0
              ? 0
              : +reservationBreakdown[i].totalFee;
          break;
        }
      }
    }
    reservationBreakdown = reservationBreakdown;
    ProductionReservation.channelCommissionRateValue =
      channelCommissionRate.toFixed(2);
    ProductionReservation.channelVatValue = channelVat.toFixed(2);
    ProductionReservation.serviceCostsValue = serviceCosts.toFixed(2);
    ProductionReservation.airbetterRateValue = airbetterRate.toFixed(2);
    ProductionReservation.airbetterVatValue = airbetterVat.toFixed(2);
    ProductionReservation.netToHostValue = (
      +ProductionReservation.sellRateValue -
      +ProductionReservation.channelCommissionRateValue -
      +ProductionReservation.channelVatValue -
      +ProductionReservation.airbetterRateValue -
      +ProductionReservation.airbetterVatValue -
      +ProductionReservation.serviceCostsValue
    ).toFixed(2);
  }
  function validateBreakdown() {
    let valid = true;
    for (let i = 0; i < reservationBreakdown.length; i++) {
      if (reservationBreakdown[i].type == "") {
        valid = false;
      }
      if (reservationBreakdown[i].fee == "") {
        valid = false;
      }
      if (reservationBreakdown[i].feeType == "") {
        valid = false;
      }
      if (reservationBreakdown[i].feeUnit == "") {
        valid = false;
      }
      if (reservationBreakdown[i].description == "") {
        valid = false;
      }
      if (reservationBreakdown[i].totalFee == "") {
        valid = false;
      }
    }
    if (valid == false) {
      error = "One or more fields on the breakdown are incomplete";
      return false;
    }
    return valid;
  }
  function saveBreakdown() {
    if (validateBreakdown()) {
      // first delete the ones to delete
      for (let x = 0; x < queueForRemoval.length; x++) {
        deleteFee(queueForRemoval[x].id);
      }
      storeReservationBreakdowns();
      return true;
    }
    return false;
  }
  async function updateReservation() {
    loadingFetch = true;
    recalculateAll();
    if (saveBreakdown()) {
      const formData = new FormData();
      formData.append("reservationId", ProductionReservation.id);
      if (ProductionReservation.sellRateValue !== null) {
        formData.append("sellRate", ProductionReservation.sellRateValue);
      }
      if (ProductionReservation.commissionableRateValue !== null) {
        formData.append(
          "commissionableRate",
          ProductionReservation.commissionableRateValue
        );
      }
      if (ProductionReservation.channelCommissionRateValue !== null) {
        formData.append(
          "channelCommissionRate",
          ProductionReservation.channelCommissionRateValue
        );
      }
      if (ProductionReservation.channelVatValue !== null) {
        formData.append("channelVat", ProductionReservation.channelVatValue);
      }
      if (ProductionReservation.airbetterRateValue !== null) {
        formData.append(
          "airbetterRate",
          ProductionReservation.airbetterRateValue
        );
      }
      if (ProductionReservation.airbetterVatValue !== null) {
        formData.append(
          "airbetterVat",
          ProductionReservation.airbetterVatValue
        );
      }
      if (ProductionReservation.serviceCostsValue !== null) {
        formData.append(
          "serviceCosts",
          ProductionReservation.serviceCostsValue
        );
      }
      if (ProductionReservation.worldPayStatus !== null) {
        formData.append("worldPayStatus", ProductionReservation.worldPayStatus);
      }
      if (ProductionReservation.paymentStatus !== null) {
        formData.append("paymentStatus", ProductionReservation.paymentStatus);
      }
      if (ProductionReservation.netToHostValue !== null) {
        formData.append("netToHost", ProductionReservation.netToHostValue);
      }
      if(ProductionReservation.paymentMethod !== null){
        formData.append('paymentMethod', ProductionReservation.paymentMethod);
      }
      if(ProductionReservation.guestPayment !== null){
        formData.append('guestPayment', ProductionReservation.guestPayment);
      }
      const response = await fetchNodeProduction(
        "/updateReservationFinancials",
        formData
      );
      if (typeof response === "object") {
        if (response.status) {
          message = parseMessage(response.data);
        } else {
          error = parseMessage(response);
        }
      }
    }
    loadingFetch = false;
  }

  async function sendPaymentLink() {
    loadingFetch = true;
    const formData = new FormData();
    formData.append("reservationId", ProductionReservation.id);
    formData.append("recipient", "guest");
    formData.append("generatePaymentLink", "yes");
    formData.append("emailType", "confirmation");
    formData.append("sendGuest", "yes");
    const response = await fetchNodeProduction(
      "/sendNewReservationEmail",
      formData
    );
    if (typeof response === "object") {
      if (response.status) {
        message = parseMessage(response.data);
      } else {
        error = parseMessage(response);
      }
    }
    loadingFetch = false;
  }
  async function updateRatesFunction(repopulateSell){
    loadingFetch = true;
   
    try {
      error = "";
      message = "";
      const formData = new FormData();
      formData.append("reservationId", ProductionReservation.id);
      formData.append('repopulateSell', (repopulateSell == true ? '1' : '0'));
      let response = await fetchNodeProduction(
        "/updateReservationPricing",
        formData
      );
      if (typeof response === "object") {
        if (response.status == true) {
          message = parseMessage(response.data);
          if(repopulateSell){
            await getBreakdowns()
          }
        } else {
          error = parseMessage(response);
        }
      }
      loadingFetch = false;
    } catch (ex) {
      console.log(ex);
    } finally {
      loadingFetch = false;
    }

  }
</script>

{#if error}
  <small>
    <strong>
      <p class="red-font">
        {error}
      </p>
    </strong>
  </small>
{/if}
{#if message}
  <small>
    <strong>
      <p class="blue-font">
        {message}
      </p>
    </strong>
  </small>
{/if}
{#if loading === false}
  <div class="scrollable max-half-screen">
    <h2>Finance</h2>
    <div class="form-group-row">
      <label for="sellRate">Sell rate:</label>
      <input name="sellRate" bind:value={ProductionReservation.sellRateValue} />
    </div>
    <div class="form-group-row">
      <label for="commissionableRate">Commissionable rate:</label>
      <input
        name="commissionableRate"
        bind:value={ProductionReservation.commissionableRateValue}
      />
    </div>
    <div class="scrollable">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Type</th>
            <th>Fee</th>
            <th>Comm Rate</th>
            <th>Unit</th>
            <th>Description</th>
            <th>Deduct Fee</th>
            <th>actions</th>
            <th>Total Fee</th>
          </tr>
        </thead>
        <tbody>
          {#each reservationBreakdown as feeLine, feeIndex}
            <tr>
              <td>
                <select
                  name="type"
                  bind:value={feeLine.type}
                  on:blur={() => recalculateAll()}
                >
                  {#each feeStructure.types as type}
                    <option value={type}>{type}</option>
                  {/each}
                </select>
              </td>
              <td
                ><input
                  bind:value={feeLine.fee}
                  type="number"
                  on:change={() => recalculateAll()}
                /></td
              >
              <td>
                <select
                  name="feeType"
                  bind:value={feeLine.feeType}
                  on:blur={() => recalculateAll()}
                >
                  {#each feeStructure.feeTypes as feeType}
                    <option value={feeType}>{feeType}</option>
                  {/each}
                </select>
              </td>
              <td>
                <select
                  name="feeUnit"
                  bind:value={feeLine.feeUnit}
                  on:blur={() => recalculateAll()}
                >
                  {#each feeStructure.feeUnits as feeUnit}
                    <option value={feeUnit}>{feeUnit}</option>
                  {/each}
                </select>
              </td>
              <td><input bind:value={feeLine.description} /></td>
              <td>
                <Toggle
                  bind:checked={feeLine.deductFee}
                  on:change={() => recalculateAll()}
                />
              </td>
              <td>
                <i class="fas fa-plus-circle" 
                  on:click={() => addBreakdownLine(feeIndex)} 
                  data-container="body" 
                  placement="top" 
                  ngbTooltip="">
                </i>
                <Confirm themeColor="350" confirmTitle="Remove" let:confirm={confirmThis}>
                  <i class="fas fa-minus-circle" 
                    on:click={() => confirmThis(removeBreakdownIndex,feeIndex)} 
                    data-container="body" 
                    placement="top" 
                    ngbTooltip="">
                  </i>
                  <span slot="title"> Remove breakdown line </span>
                  <span slot="description">
                    <p>Are you sure you want to remove this</p> 
                    <p>breakdown line?</p>
                  </span>
                </Confirm>
              </td>
              <td>{feeLine.totalFee}</td>
            </tr>
          {/each}
        </tbody>
      </table>
    </div>
    <div class="form-group-row">
      <label for="channelCommissionRate">Channel commission paid:</label>
      <input
        name="channelCommissionRate"
        bind:value={ProductionReservation.channelCommissionRateValue}
      />
    </div>
    <div class="form-group-row">
      <label for="channelVat">Channel VAT:</label>
      <input
        name="channelVat"
        bind:value={ProductionReservation.channelVatValue}
      />
    </div>
    <div class="form-group-row">
      <label for="airbetterRate">Airbetter rate:</label>
      <input
        name="airbetterRate"
        bind:value={ProductionReservation.airbetterRateValue}
      />
    </div>
    <div class="form-group-row">
      <label for="airbetterVat">Airbetter VAT:</label>
      <input
        name="airbetterVat"
        bind:value={ProductionReservation.airbetterVatValue}
      />
    </div>
    <div class="form-group-row">
      <label for="serviceCosts">Total of other costs:</label>
      <input
        name="serviceCosts"
        bind:value={ProductionReservation.serviceCostsValue}
      />
    </div>
    <div class="form-group-row">
      <label for="netToHost">Net to host:</label>
      <input
        name="netToHost"
        bind:value={ProductionReservation.netToHostValue}
      />
    </div>
    <div class="form-group-row">
      <label for="paymentStatus">Payment status:</label>
      <select
        name="paymentStatus"
        bind:value={ProductionReservation.paymentStatus}
      >
        {#each paymentStatuses as paymentStatus}
          <option value={paymentStatus}>{paymentStatus}</option>
        {/each}
      </select>
    </div>
    <div class="form-group-row">
      <label for="paymentDate">Payment date:</label>
      <input
        name="paymentDate"
        bind:value={ProductionReservation.paymentDate}
      />
    </div>
    <div class="form-group-row">
      <label for="paymentMethod">Host Payment method:</label>
      <select
        name="paymentMethod"
        bind:value={ProductionReservation.paymentMethod}
      >
        {#if ProductionReservation.paymentMethod == 'Stripe'}
          <option value="Stripe">Stripe</option>
        {/if}
        {#each paymentMethods as paymentMethod}
          <option value={paymentMethod}>{paymentMethod}</option>
        {/each}
      </select>
    </div>
    <div class="form-group-row">
      <label for="guestPayment">Guest Payment method:</label>
      <select
        name="guestPayment"
        bind:value={ProductionReservation.guestPayment}
      >
      {#each guestPaymentMethod as guestPaymentMethods}
        <option value={guestPaymentMethods}>{guestPaymentMethods}</option>
      {/each}
      </select>
    </div>
    <button
      type="submit"
      on:click={() => updateReservation()}
      class="pink-button"
      disabled={loadingFetch}
    >
      {loadingFetch ? "Loading..." : "Save breakdown"}
    </button>
    <!--
      
        <label for="paymentStatus">Payment status:</label>
        <input
          name="paymentStatus"
          bind:value={ProductionReservation.paymentStatus}
        />
      
    -->

    <h2>Resend guest email</h2>
    <Confirm themeColor="350" confirmTitle="Send Email" let:confirm={confirmThis}>
      <button
        type="submit"
        on:click={() => confirmThis(sendPaymentLink)}
        class="pink-button"
        disabled={loadingFetch}
      >
        {loadingFetch ? "Loading..." : "Resend guest email"}
      </button>
      <span slot="title"> Send email </span>
      <span slot="description">
        <p>Are you sure you want to send the email to</p> 
        <p>{ProductionReservation.guestEmail}?</p>
      </span>
    </Confirm>

    <h2>Repopulate reservation rates</h2>
    <Confirm themeColor="350" confirmTitle="Populate fees" let:confirm={confirmThis}>
      <button
        type="submit"
        on:click={() => confirmThis(updateRatesFunction,true)}
        class="pink-button"
        disabled={loadingFetch}
      >
        {loadingFetch ? "Loading..." : "Populate fees"}
      </button>
      <span slot="title"> Populate fees </span>
      <span slot="description">
        <p>Are you sure you want to regenerate the breakdown<br/> of fees for this booking?</p> 
        
      </span>
    </Confirm> <br/>
    <Confirm themeColor="350" confirmTitle="Populate sell rate and fees" let:confirm={confirmThis}>
      <button
        type="submit"
        on:click={() => confirmThis(updateRatesFunction,false)}
        class="pink-button"
        disabled={loadingFetch}
      >
        {loadingFetch ? "Loading..." : "Populate sell rate and fees"}
      </button>
      <span slot="title"> Populate sell rate and fees </span>
      <span slot="description">
        <p>Are you sure you want to regenerate the breakdown<br/> of fees for this booking?</p> 
      </span>
    </Confirm>
  </div>
{/if}

<style>
  .scrollable {
    overflow: auto;
    white-space: nowrap;
    padding-right: 20px;
  }
  .max-half-screen {
    max-height: 50vh;
  }
  .form-group-row {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    flex: 1;
    margin-bottom: 10px;
  }
  .form-group-row label {
    position: relative;
    top: 8px;
    margin-right: 20px;
  }
  .pink-button {
    background-color: #ed4368;
    color: #fff;
    margin-top: 10px;
    width: 100%;
  }
  .red-font {
    color: rgb(194, 32, 32);
  }

  .table {
    width: 100%;
    max-width: 100%;
    margin-bottom: 1rem;
  }

  .table th,
  .table td {
    padding: 0.75rem;
    vertical-align: top;
    border-top: 1px solid #eceeef;
  }

  .table thead th {
    vertical-align: bottom;
    border-bottom: 2px solid #eceeef;
  }

  .table-bordered thead th {
    border-bottom-width: 2px;
  }

  .table-striped tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05);
  }

  .table-hover tbody tr:hover {
    background-color: rgba(0, 0, 0, 0.075);
  }

  .table-inverse thead th {
    border-color: #fff;
  }
  select {
    min-width: 244px;
  }
  .fa-plus-circle {
    font-size:20px;
  	color:#0079FE !important;	
  }
  .fa-plus-circle:hover {
  	color: #0067d8 !important;
  }
  .fa-minus-circle  {
    font-size:20px;
  	color:#ed1c24 !important;
  }
  .fa-minus-circle:hover {
  	color: #d4121a !important;	
  }
</style>
